import React from 'react';
import promo from '../assets/promo.jpg';

const Promo = () => {
  return (
    <section className="section relative overflow-hidden group" id="promo">
      <img
        className="absolute inset-0 object-[75%] sm:object-[25%] object-cover w-full h-full opacity-40 sm:opacity-100 group-hover:scale-110 transition duration-500 ease-linear"
        src={promo}
        alt="Couple on a bed with a dog"
      />

      <div className="hidden sm:block sm:inset-0 sm:absolute sm:bg-gradient-to-tr sm:from-green-100 sm:to-transparent"></div>

      <div className="relative section-center lg:h-3/4 lg:items-center lg:flex">
        <div className="max-w-xl text-center sm:text-left">
          <h2 className="text-3xl font-extrabold sm:text-5xl">
            Let us take you around
            <p className="font-extrabold text-green-800 mt-4">Vietnam</p>
          </h2>

          <p className="max-w-lg my-8 sm:leading-relaxed sm:text-xl">
            Vietnam is an exhilarating country to travel, home to breathtaking
            nature, vibrant culture and friendly people.
          </p>

          <div className="flex flex-col sm:flex-row mt-8 text-center ">
            <a
              className="px-6 py-3 text-sm font-medium text-white rounded shadow bg-green-700 sm:w-auto active:bg-green-600 hover:bg-green-800 focus:outline-none focus:ring mb-4 sm:mb-0 sm:mr-8 "
              href="#tips"
            >
              Contact
            </a>

            <a
              className="px-6 py-3 text-sm font-medium bg-white rounded shadow text-green-600 sm:w-auto hover:text-green-700 active:text-green-500 focus:outline-none focus:ring"
              href="#whyUs"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Promo;
